import { Subject } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable()
export class ScrollService {

  private expandLiveEventSource = new Subject<boolean>();
  public expandLiveEvent$ = this.expandLiveEventSource.asObservable();

  expandEventLiveChange(status: boolean){
    this.expandLiveEventSource.next(status);
  }

}
